import { BLOCKS } from '@contentful/rich-text-types';
import { resolveRichTextNode } from 'connectors/utils/resolve-rich-text-node';
import isObject from 'lodash/isObject';

interface ResolveRichTextLinks<T> {
  value: T;
  links: Partial<Record<string, string>>;
}

/** Extracts a button URL from the links already resolved for the whole response. */
export const resolveRichTextLinks = <T>({ value, links }: ResolveRichTextLinks<T>): T | string => {
  const isRichTextDocument =
    isObject(value) && 'nodeType' in value && value.nodeType === BLOCKS.DOCUMENT;

  if (!isRichTextDocument) {
    return value;
  }

  const result = resolveRichTextNode(value);

  if (result.type === 'entry-hyperlink') {
    return result.entryId ? (links[result.entryId] ?? '') : '';
  }

  return result.value;
};
